import { reverse } from 'named-urls';
import React from 'react';
import { Link } from 'react-router-dom';
import { useDashboardPermissions } from '@components/utils/DashboardPermissions';
import { List, Table, useMediaQueryContext } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { useShopTime } from '../../../../../../../../../Timezone/providers/ShopTimeProvider';
import { getTableHeaders } from '../../utils/getTableHeaders';
import { DonationListItem } from '../DonationListItem/DonationListItem';
const getDonationLink = (donation) => ({
    pathname: reverse(routing.contributions.orders.donations.donation.self, {
        donationId: donation.id,
    }),
    search: location.search,
});
export const DonationsData = ({ data, isLoading }) => {
    const { hasPermission } = useDashboardPermissions();
    const media = useMediaQueryContext();
    const { timezoneAbbreviation } = useShopTime();
    if (!media.tablet) {
        return (React.createElement(List, { data: data, isLoading: isLoading, renderItem: (donation) => React.createElement(DonationListItem, { donation: donation }), getItemLink: getDonationLink }));
    }
    return (React.createElement(Table, { data: data, headers: getTableHeaders({
            hideProfitColumn: !hasPermission('contributions.profit'),
            timezoneAbbreviation,
        }), isLoading: isLoading, rowComponent: Link, getRowLink: getDonationLink }));
};
